// extracted by mini-css-extract-plugin
module.exports = {"title":"_2mTZOVt0","error":"RTg6JboH","cred":"_3MzgDqGC","selection":"_3rMkUZnw","submit":"_2rcuS4RD"};